export default __webpack_public_path__ + "static/media/icon-repaired-screen.d5ca01a0.svg";